import { useState } from "react";
import { DateTime } from "luxon";
import { Colors, formatDate } from "swing-components";

import { translate } from "~utils";

type DaysConflictProps = {
  readonly days?: DateTime[];
};

export function DaysConflict(props: DaysConflictProps) {
  const { days } = props;

  const [showAllDays, setShowAllDays] = useState(false);

  if (!days || days.length === 0) {
    return null;
  }

  const sortedDays = days.sort((a, b) => (a < b ? -1 : 1));
  const uniqueDays = removeDuplicates(sortedDays);
  const firstColumn = showAllDays
    ? uniqueDays.slice(0, Math.ceil(uniqueDays.length / 2))
    : uniqueDays.slice(0, 6);
  const secondColumn = showAllDays
    ? uniqueDays.slice(Math.ceil(uniqueDays.length / 2))
    : uniqueDays.slice(6, 12);

  return (
    <div
      css={{
        borderRadius: 8,
        background: Colors.white300,
        padding: 8,
      }}
    >
      <h3 css={{ fontSize: "14px !important", margin: 0, marginBottom: 8, fontWeight: 600 }}>
        {translate("DAYS_CONFLICT_HEADER")}
      </h3>
      <p css={{ fontSize: 12, margin: 0, marginBottom: 8 }}>
        {translate("DAYS_CONFLICT_DESCRIPTION")}
      </p>
      <ul css={styles.list}>
        {firstColumn.map((day) => (
          <li key={day}>{day}</li>
        ))}
      </ul>
      {secondColumn.length > 0 && (
        <ul css={{ ...styles.list, marginLeft: 24 }}>
          {secondColumn.map((day) => (
            <li key={day}>{day}</li>
          ))}
        </ul>
      )}
      {days.length > 12 && !showAllDays && (
        <button
          css={{ display: "block", margin: 0, fontSize: 12, color: Colors.blue500 }}
          onClick={() => setShowAllDays(true)}
        >
          {translate("LABEL_SHOW_ALL_DAYS")}
        </button>
      )}
    </div>
  );
}

const styles = {
  list: {
    display: "inline-block",
    margin: 0,
    marginBottom: 8,
    paddingLeft: 16,
    fontSize: 12,
    verticalAlign: "top",
  },
};

/**
 * Creates an array of unique days from a list of days.
 * @param days - A list of days.
 * @returns An array of unique days.
 */
export function removeDuplicates(days: DateTime[]) {
  return [...new Set(days.map((date) => formatDate({ date, format: "Wed, Jan 1" })))];
}
